import { message } from "antd";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppHeader from "../../../../components/AppHeader/AppHeader";
import useFetchUserInfos from "../../../../hooks/userHooks/useFetchUserInfos";
import { useAppDispatch } from "../../../../redux/hooks";
import { clearTrackingLinksCache } from "../../../../redux/trackingLinks/slices/trackingLinkSlice";
import { fetchTrackingLinks } from "../../../../redux/trackingLinks/thunks/trackingLinksThunks";
import { trackingLinksService } from "../../../../services/tracking-links.service";
import "./index.less";
import SpinnerComponent from "../../../../components/SpinnerComponent/SpinnerComponent";

const TrackingLinkCreateView: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { currentUser } = useFetchUserInfos();
  const currentCreator = currentUser?.id;

  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);

  const isConfirmDisabled = useMemo(() => title.trim().length === 0, [title]);

  const handleConfirm = async () => {
    if (title?.trim() === "") {
      message.error(t("please-enter-a-name-for-your-tracking-link"));
      return;
    }

    setLoading(true);
    try {

      await trackingLinksService.createTrackingLinks({
        title
      }).then((res: any) => {
        if (res) {
          message.success(t("tracking-link-created-successfully"));
        }
      });

      dispatch(clearTrackingLinksCache());
      if (currentCreator) {
        await (dispatch as any)(fetchTrackingLinks({ creatorId: currentCreator }));
      }

      navigate(-1);
    } catch (e: any) {
      if (e.response.data.message) {
        message.error(t(e.response.data.message))
      } else {
        message.error(t("back-error-message"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tracking-link-create-view">
      <AppHeader
        title={t("new-tracking-link")}
        backButtonDestination={-1}
        showBackButton={true}
        onBackClick={() => navigate("/creator/tracking-links")}
      />

      <div className="tracking-link-create-content" style={{ minHeight: "auto" }}>
        <div className="step step-title create-form">
          <div className="centered-block">
            <div className="form-container">
              <h2 className="tracking-link-create-form-title">{t("give-your-tracking-link-a-name")}</h2>
              <div className="tracking-link-create-input-group">
                <input
                  type="text"
                  className="tracking-link-create-title-input"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder={t("my-name") as string}
                  autoFocus
                />
                <div className="tracking-link-create-input-underline" />
              </div>
            </div>
          </div>
          <div className="bottom-button-wrapper">
            <button className="tracking-link-create-button tracking-link-create-button--default" onClick={handleConfirm} disabled={isConfirmDisabled}>
              {t("create-tracking-link")}
            </button>
          </div>
        </div>
      </div>

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            zIndex: 9999,
          }}
        >
          <SpinnerComponent progress={false} />
        </div>
      )}
    </div>
  );
};

export default TrackingLinkCreateView;
